import {
  BasketColumnKeys,
  BasketRow,
  BasketRowsGroup,
} from 'graphql-api/baskets-api-interfaces';

import {
  getColumnConfirmedValue,
  getColumnRequestedValue,
} from './map-column-display-values';

export function getLineColumnValues(
  group: BasketRow | BasketRowsGroup,
  columnToFind: BasketColumnKeys,
) {
  const column = group.columns.find(({ key }) => key === columnToFind);

  const columnRequestedValue = getColumnRequestedValue(column);
  const columnConfirmedValue = getColumnConfirmedValue(column);

  const requestedNumber = columnRequestedValue
    ? parseFloat(columnRequestedValue)
    : null;
  const confirmedNumber = columnConfirmedValue
    ? parseFloat(columnConfirmedValue)
    : null;

  return confirmedNumber ?? requestedNumber;
}
